// A Kripto Start leckeszámai szintenként (SZINTMATRIX; a publikált leckék a modul szintje szerint).
// Plusz 2. kör: FREE 35, TAG 85, Plusz és PRO 133. Tananyag 1. kör: + a 9.0 lecke (TAG-szint)
// → FREE 35, TAG 86, Plusz és PRO 134. Csak ott használjuk, ahol az adat nincs kéznél (a kurzuslista);
// a kurzusoldal a course_outline-ból számol (leckeszamSzintenkent). Ha a DB-ben változik, a landing
// scripts/leckek-1/run-test.mjs leckeszám-esete jelez.
export const FREE_LESSONS = 35;
export const TAG_LESSONS = 86;
export const KS_LESSONS = 134;
// Navigáció 1: ennyivel több lecke nyílik a TAG-gal (a feliratok innen veszik: 86 − 35 = 51). A DB-vel való
// egyezést a landing scripts/navigacio-1/run-test.mjs is méri (a publikált, nem rejtett leckék szintenként).
export const TAG_EXTRA_LESSONS = TAG_LESSONS - FREE_LESSONS;
